












































/* eslint-disable */

import Vue from "vue";
import fb from "../config";
import router from './router/routes.vue';

export default Vue.extend({
  name: "#contact",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    login() {
      var cur = this;

    fb.auth().signInWithEmailAndPassword(this.email,this.password).then(function() {
        fb.firestore()
        .collection("userlogs")
        .add({
          email: cur.email,
          time:new Date().toLocaleString(),
          action:'logged in'
          
        })
        .then(function() {
          alert("Logged in Successfully");
          sessionStorage.setItem('user',cur.email);
          cur.$router.push({ path: '/index' })
        })
        .catch(function() {
          alert("Error While Login Please Check Your Credentials And Try Again");
        });
    }).catch(function(){
        fb.firestore()
        .collection("ErrorLog")
        .add({
          email: cur.email,
          password:cur.password,
          Error:"Failed To Login",
          time:new Date().toLocaleString()
          
        })
        alert("Error While Login Please Check Your Credentials And Try Again");
    })

      
    },
  },
});
